
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

export const allergens = () => {

    const allergensComponent = document.querySelector('.m__allergens');
    const allergensResults = document.querySelector('.m__allergens__results');
    const resetButton = document.querySelector('.js-reset-allergens');

    if(allergensComponent) {

    	const allergensDropdown = allergensComponent.querySelector('.js-toggle-dropdown');
        const allergensDropdownText = allergensDropdown.querySelector('p');
        const allergensDropdownList = allergensDropdown.querySelector('ul');
       
        allergensDropdown.addEventListener('click', function() {
            allergensDropdown.classList.toggle('active');
        });

        allergensDropdownList.addEventListener('click', function(e) {

            if (e.target.tagName === 'P') {

                const selectedText = e.target.textContent.trim();
                const allergensLocationId = e.target.getAttribute('data-id');
                allergensDropdownText.textContent = selectedText;

                allergensResults.classList.add('active');

                const elementToActivate = document.querySelector(`.m__allergens__card#allergen-${allergensLocationId}`);

                if (elementToActivate) {
                    document.querySelectorAll('.m__allergens__card').forEach(card => card.classList.remove('active'));
                    elementToActivate.classList.add('active');
                }

                let elementToScrollTo = allergensResults;
                if(elementToScrollTo){
                    gsap.registerPlugin(ScrollToPlugin);
                    const targetPosition = elementToScrollTo.offsetTop - 50;
                    gsap.to(window, {duration: 1, scrollTo: targetPosition});
                }
            }

            if(e.target.tagName === 'A') {
                const selectedText = e.target.textContent.trim();
                allergensDropdownText.textContent = selectedText;
            }
        });

        resetButton.addEventListener('click', function() {
            // Reset dropdown text
            const allergensDropdown = allergensComponent.querySelector('.js-toggle-dropdown');
            const allergensDropdownText = allergensDropdown.querySelector('p');
            allergensDropdownText.textContent = 'Location'; // Default text

            // Close the dropdown if active
            allergensDropdown.classList.remove('active');

            // Remove active class from all allergen cards
            document.querySelectorAll('.m__allergens__card').forEach(card => {
                card.classList.remove('active');
            });

            // Hide allergens results if needed
            if (allergensResults.classList.contains('active')) {
                allergensResults.classList.remove('active');
            }

            // Optional: Scroll back to the top or a specific section if required
            gsap.registerPlugin(ScrollToPlugin);
            gsap.to(window, {duration: 1, scrollTo: 0});
        });
    }
}